import styles from "./Grain.module.css";

/**
 * Subtle full-screen film-grain overlay for a "shot, not built" texture.
 * Purely decorative; hidden for reduced-motion users.
 */
export function Grain() {
  return <div className={styles.grain} aria-hidden="true" />;
}
